import React, { useState } from 'react';
import { FormGroup, Label, Input } from 'reactstrap'

function CustomInput(props) {

    const [errMsg, setErrMsg] = useState('');
    const validate = e => {
        props.onChange(e);
        if (props.pattern && !(new RegExp(props.pattern)).exec(e.target.value)) {
            setErrMsg(props.errMsg);
        } else {
            setErrMsg('');
        }
    }

  return (
        <FormGroup>
            <Label style={{'color': 'grey'}}>{props.name1}</Label>
          <br />
          <Label style={{ 'color': 'grey' }}>{props.name2} <span className="text-danger">*</span></Label>
          <Input
              required
              type={props.type}
                pattern={props.pattern}
                disabled={props.disabled}
                onChange={validate}
              value={props.value} />
          <Label style={{ 'color': 'red' }}>{errMsg}</Label>
          <Label style={{ 'color': 'grey' }}>{props.desc1}</Label>
          {props.desc2 && <br />}
          <Label style={{ 'color': 'grey' }}>{props.desc2}</Label>
        </FormGroup>
  );
}

export default CustomInput;